export default __webpack_public_path__ + "static/media/ast-798150.e22e4736.jpg";